import { useEffect, useState } from 'react';
import {Button, Col, Container, Row, Spinner, Alert} from 'react-bootstrap';
import { api } from '../services/Api';
import { useAlert } from '../contexts/AlertContext';
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet.png";
import CryptoJS from "crypto-js";
import {CardInfo} from "../components/CardInfo/CardInfo";
import {CardHeader} from "../components/CardHeader/CardHeader";
import {CardBody} from "../components/CardBody/CardBody";
import {Input} from "../components/Input/Input";
import {useAuth} from "../contexts/AuthenticationContext";

interface AttachmentsProps {
	id: number;
	id_contrato_anexo_link: number;
	nome: string;
	nome_curto: string;
	tipos: string;
}

export function Attachments() {
	const url = window.location.href.split('anexos/');
	const token = url[1];
	const { handleSetAlert } = useAlert();

	const { session } = useAuth();

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
	const [attachments, setAttachments] = useState<AttachmentsProps[] | []>([]);
	const [attachmentsSelected, setAttachmentsSelected] = useState([]);
	const [tags, setTags] = useState('');
	const [idContract, setIdContract] = useState('');

	useEffect(() => {
		if (session) {
			let obj_json = JSON.parse(atob(token));
			let key = CryptoJS.PBKDF2(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_KEY as string, process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_SALT as string, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999});
			let decrypted = CryptoJS.AES.decrypt(obj_json.ciphertext, key, { iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_IV_HEX as string)});
			let dataParameters = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

			if (dataParameters.d === '') {
				setError('Documento está em branco');
				setLoading(false);
			} else if (dataParameters.t === '') {
				setError('Telefone está em branco');
				setLoading(false);
			}

			setIdContract(dataParameters.rb.id_contrato);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/contratos/anexos/links/'+dataParameters.rb.id_anexo, { headers })
				.then((response) => {
					setTags(response.data.tags);
					setAttachments(response.data.anexos);
					setLoading(false);
				})
				.catch((error) => {
					setError(error.response.data.message);
					setLoading(false);
				});
		}
	},[session, token])

	async function handleAttachments() {
		if (session) {

			if (!attachmentsSelected) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Selecione pelo menos um anexo',
					timeout: 5000
				});
				return false;
			}

			setLoading(true);

			let attachmentsData: { nome: never; anexo: string; }[] = [];

			for (const i in attachmentsSelected) {
				let key = Object.keys(attachmentsSelected[i]);
				for (let x=0; x<key.length; x++){
					try {
						let attachmentData = await handleFileReader(attachmentsSelected[i][key[x]]) as { nome: never; anexo: string; };
						attachmentsData.push(attachmentData);
					} catch (error) {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: error,
							timeout: 5000
						});
						setLoading(false);
						return false;
					}
				}
			}

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			let data = {
				id: idContract,
				tags: tags.replace('[', '').replace(']', '').split(','),
				anexos: attachmentsData
			}

			api.post('v1/contratos/anexar', data, {headers})
				.then(async (response: any) => {
					setSuccess(response.data.message)
					setLoading(false);
				}).catch((error) => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
					setAttachmentsSelected([]);
					setLoading(false);
				})
		}
	}

	function handleFileReader(attachment: any) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			reader.readAsDataURL(attachment);
			reader.onload = () => {
				let aux = reader.result?.toString().split('base64,');
				if (aux) {
					resolve({
						nome: attachment['name'],
						anexo: aux[1]
					})
				} else {
					reject('Problema ao anexar arquivos, recarregue a página e tente novamente')
				}
			}
			reader.onerror = () => {
				reject('Problema ao anexar arquivos, recarregue a página e tente novamente')
			}
		})
	}

	return(
		<>
			<Navbar collapseOnSelect style={{height: 80}} className="header p1" expand="lg">
				<Container>
					<Navbar.Brand>
						<img src={logoImg} alt="Logo Netcomet"/>
					</Navbar.Brand>
					<a href="https://cliente.netcomet.com.br/login" rel="noreferrer" target="_blank">
						<Navbar.Brand className="d-flex align-items-center color-dark-gray">
							<span className="material-icons title-icon">face</span>
							<p className="m-0">Portal do Cliente</p>
						</Navbar.Brand>
					</a>
				</Container>
			</Navbar>
			<Container className="container-login p-3">
				{(loading || (!loading && error) || (!loading && success)) && <Row className="h-100">
					<Col md={12} className="align-self-center">
						{loading && <div className="justify-content-center align-items-center d-flex">
							<Spinner animation="border" role="status"/>
						</div>
						}
						{!loading && error && !success && <div className="justify-content-center align-items-center d-flex">
							<Alert variant="danger">{error}</Alert>
						</div>}
						{!loading && !error && success && <div className="justify-content-center align-items-center d-flex">
							<Alert variant="success">{success}</Alert>
						</div>}
					</Col>
				</Row>}
				{!loading && !error && !success && <>
					<Row>
						<Row className="m-card">
							<Col md={12} className="d-flex justify-content-center">
								<CardInfo variant="w-100">
									<CardHeader variant="card-header-info">
										<div className="d-flex">
											ANEXE DOCUMENTO(S) AO SEU CONTRATO
										</div>
									</CardHeader>
									<CardBody>
										<Row className="d-flex m-0">
											{attachments?.map((item, key) => (
												<div key={key}>
													<Row className="m-3">
														<Col md={4} className="attachment d-grid">
															<span className={`material-icons title-icon text-center ${attachmentsSelected[key] ? 'color-dark-gray' : 'color-light-gray'}`}>{attachmentsSelected[key] ? 'insert_drive_file' : 'wallpaper'}</span>
															<p className="text-center">{attachmentsSelected[key] ? `${Object.keys(attachmentsSelected[key]).length} Documento(s) Selecionado(s)` : ''}</p>
														</Col>
														<Col md={8} className="text-center align-self-center">
															<p className="text-uppercase">{item.nome}</p>
															<label className="btn-file">
																<Input
																	type="file"
																	onChange={(value) => {
																		let dataValue = [...attachmentsSelected] as any;
																		const fileList = value.target.files;
																		if (fileList) {
																			if (dataValue[key]) {
																				for (let i = 0; i < fileList.length; i++) {
																					dataValue[key] = [...dataValue[key],  fileList[i]];
																				}
																			} else {
																				dataValue[key] = value.target.files;
																			}
																		}
																		setAttachmentsSelected(dataValue);
																	}}
																	multiple
																	accept={item.tipos}
																	style={{display: 'none'}}
																/> Selecionar
															</label>
														</Col>
														<Col md={12}>
															<hr/>
														</Col>
													</Row>
												</div>
											))}
											<Col md={12} className="text-center mb-3">
												<Button variant={"success"} className="p-2" onClick={() => handleAttachments()}>ENVIAR ANEXOS</Button>
											</Col>
										</Row>
									</CardBody>
								</CardInfo>
							</Col>
						</Row>
					</Row>
				</>}
			</Container>
		</>
	);
}
